<!-- <div
  class="loader-ring"
  style="background-color: aqua; min-height: 5rem; min-width: 5rem"
  *ngIf="showLoader">
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div> -->
<p-dialog
  *ngIf="displayLoader"
  [(visible)]="showLoader"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '200px', background: 'transparent', border: 'none' }"
  [contentStyle]="{ 'text-align': 'center', background: 'transparent' }"
  [styleClass]="'custom-loader-dialog'">
  <ng-lottie [options]="options" [width]="'50'" [height]="'50'" />
</p-dialog>
